import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { LazyLoadComponent, } from "@moodys/mdc-frontend.helpers.lazy-load-component";
import { logger } from "@moodys/mdc-frontend.services.logger";
export const MicroFrontendLoader = ({ children, errorFallback = null, renderOnIntersect = true, skeleton = null, ...restLazyLoadProps }) => {
    return (_jsx(ErrorBoundary, { fallbackRender: ({ error }) => {
            logger.error({ error });
            return errorFallback;
        }, children: renderOnIntersect ? (_jsx(LazyLoadComponent, { skeleton: skeleton, ...restLazyLoadProps, children: children })) : (_jsx(Suspense, { fallback: skeleton, children: children })) }));
};
//# sourceMappingURL=micro-frontend-loader.js.map